import type { RequestConfig } from '@umijs/max';
import _ from 'lodash';
const cloneDeep = _.cloneDeep;
import { notification, Modal } from 'antd';
import { history } from '@umijs/max';
import { getBaseUrl } from '@/utils/util';

let hasExpired = false;

const loginPath = '/user/login';

const request: RequestConfig = {
  // baseURL:"",
  timeout: 30000,
  // other axios options you want
  errorConfig: {
    errorHandler() { },
    errorThrower() { },
  },

  // 请求拦截
  requestInterceptors: [
    // 直接写一个 function，作为拦截器
    (url, options) => {
      if (options.params) {
        Object.keys(options.params).forEach((key) => {
          if (options.params[key] === '') {
            delete options.params[key];
          }
        });
      }
      const token = window.localStorage.getItem('token') || '';
      const option = cloneDeep(options);

      option.headers = {
        ...option.headers,
        'Content-Type': 'application/json;charset=utf-8',
        Authorization: token,
      };

      const baseurl =
        process.env.NODE_ENV === 'production' ? getBaseUrl() + url : '' + url;
      return {
        url: baseurl,
        options: option,
      };
    },
    // 一个二元组，第一个元素是 request 拦截器，第二个元素是错误处理
    [
      (url, options) => {
        return { url, options };
      },
      (error) => {
        return Promise.reject(error);
      },
    ],
    // 数组，省略错误处理
    [
      (url, options) => {
        return { url, options };
      },
    ],
  ],

  // 返回拦截
  responseInterceptors: [
    // 一个二元组，第一个元素是 request 拦截器，第二个元素是错误处理
    [
      // 正常返回
      (response: any) => {
        if (response.status !== 200 && response.status !== 201) {
          notification.error({
            message: `请求错误 ${response.status}`,
            description: response.statusText,
          });
        }
        const { code, message, data } = response.data as any;
        // const errortext = codeMessage[code || status ] || message;
        if (code === 401) {
          if (history.location.pathname !== loginPath) {
            if (!hasExpired) {
              hasExpired = true;

              Modal.confirm({
                title: '系统提示',
                content: message ?? '登录状态已过期，请返回登录页面重新登录',
                okText: '重新登录',
                cancelText: '取消',
                onOk: () => {
                  hasExpired = false;
                  history.push('/user/login');
                },
                onCancel: () => {
                  hasExpired = false;
                },
              });
            }
          } else {
            notification.error({
              message: `请求错误 ${code}`,
              description: message,
            });
          }
          // notification.error({
          //   message: `登录状态错误`,
          //   description: message,
          // });
        } else if ((code !== 200 && code !== 0)) {
          notification.error({
            message: `请求错误 ${code}`,
            description: message,
          });
        }

        response["data"] = data;

        return response;
      },
      // 异常返回
      (error: any) => {
        const { code, message, data } = error.response.data as any;
        if (code === 401) {
          if (history.location.pathname !== loginPath) {
            if (!hasExpired) {
              hasExpired = true;
              Modal.confirm({
                title: '系统提示',
                content: message ?? '登录状态已过期，请返回登录页面重新登录',
                okText: '重新登录',
                cancelText: '取消',
                onOk: () => {
                  hasExpired = false;
                  history.push('/user/login');
                },
                onCancel: () => {
                  hasExpired = false;
                },
              });
            }
          }
        }
        notification.error({
          message: `请求错误 ${error.response.data.code}`,
          description: error.response.data.message,
        });
        return Promise.reject(error);
      },
    ],
  ],
};
export default request;